export enum SelectedMode {
    MANUALLY = "manually",
    FROM_LIST = "from_list",
}

export enum TypeOfListItem {
    MANUAL = "manual",
    TOP = "top",
    ALL = "all",
}

export enum TypeOfSelectors {
    EXCEL = "EXCEL",
    ACCOUNT = "ACCOUNT",
    DELETE = "DELETE",
    ASSIGN = "ASSIGN",
    EXPORT_SALES_FORCE = "EXPORT_SALES_FORCE",
    EXPORT_HUBSPOT = "EXPORT_HUBSPOT",
    EXPORT_DYNAMICS = "EXPORT_DYNAMICS",
    EXPORT_OPTIONS = "EXPORT_OPTIONS",
}

export type DropdownListItem = {
    type: TypeOfListItem;
    value: number;
    label: string;
};

export type MultiSelectorActionsState = {
    [key in TypeOfSelectors]: () => void;
};
